module.exports = __webpack_public_path__ + "img/live-1.9a7df602.png";